import axios from 'axios';
import Store from '@/config/store';

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL+'Server.php',
});

instance.interceptors.request.use(config => {
  config.headers.Authorization = `Bearer ${Store.getters['application/get_application_token']}`;
  return config;
}, err => {
  Promise.reject(err)
});

instance.interceptors.response.use(res => {

  if(res.data !== null && res.data.refresh !== undefined) {

    localStorage.setItem('satabapp-token', JSON.stringify(res.data.refresh));

    setTimeout(() => {
      Store.dispatch('application/SATABAPP_LOAD')
    }, 300);

    document.location.reload(true);

  } else {

    if(res.data !== null && res.data.status !== null && (res.data.status === 'expire' || res.data !== null && res.data.status === 'invalid')) {
  
      localStorage.removeItem('satabapp-research');
      localStorage.removeItem('satabapp-company');
      localStorage.removeItem('satabapp-user');
      localStorage.removeItem('satabapp-token');
      localStorage.removeItem('satabapp-customer');
      localStorage.removeItem('satabapp-translation');

      Store.dispatch('application/SATABAPP_RESET');
  
      document.location.reload(true);
    } 
  }

  return res;

}, err => {

  console.error(err)

  return Promise.reject(err);
});

export default instance;
